import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {gsap} from "gsap";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";

/**
 * Created by Jerker Nord on 2022-11-23.
 */

export class BenjiKIVInitialWinRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        if(BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL) {
            return (BenjiKIV.model.gameData.accumulatedRoundWin > 0);
        } else {
            return (BenjiKIV.model.gameData.totalSpinWinnings > 0);
        }
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        this._mainTL = gsap.timeline();

        this._mainTL.add(
            () => this._controller.setSkipCallback(() => this.skip())
        );
        this._mainTL.add(BenjiKIV.initialWinView.getInitialWinAnimation());
        this._mainTL.add(() => {this.complete()}, "-=0.4");
    }

    private skip():void {

    }

    private complete():void {
        this._controller.finish();
    }
}